// Клиентская аналитика — tech/03 §17, tech/09 §1 п. 3, §2 (E18-T02; заявка фронтенда, Р-103). Пачка до 100 событий,
// раз в 30 с и при уходе в фон через `navigator.sendBeacon` — он не ставит заголовков, поэтому токен можно положить в
// тело (`accessToken`, только если нет `Authorization`). Без входа — `player_id = 0`. Сверка — со словарём tech/09 §3:
// неизвестное имя или параметр вне словаря отбрасываются поштучно, пачка не падает; повтор `eventId` — дубль.
import { z } from 'zod';
import { IsoTime, strict } from '../common.js';
import { endpoint } from '../endpoint.js';
import { Ulid } from '../http.js';

const PropValue = z.union([z.string().max(256), z.number(), z.boolean(), z.null()]);

export const ClientEvent = strict({
  eventId: Ulid,
  name: z.string().regex(/^[a-z][a-z0-9_]{0,47}$/),
  seq: z.int().nonnegative(),
  /** Время клиента; сервер поправит смещением `sentAt` → время приёма. */
  ts: IsoTime,
  props: z.record(z.string().max(48), PropValue).optional(),
});

export const analyticsBatch = endpoint({
  id: 'analytics.batch', method: 'POST', path: '/analytics/batch', auth: false, signed: false, idempotency: 'none', rate: 'analytics',
  body: strict({
    sessionId: Ulid,
    sentAt: IsoTime.optional(),
    ctx: strict({ platform: z.string().max(32), tgVersion: z.string().max(16).optional(), clientBuild: z.string().max(32).optional() }).optional(),
    accessToken: z.string().max(2048).optional(),
    events: z.array(ClientEvent).min(1).max(100),
  }),
  response: strict({ accepted: z.int().nonnegative(), rejected: z.array(strict({ eventId: z.string(), reason: z.enum(['unknown_event', 'unknown_param', 'server_only', 'duplicate']) })) }),
  status: 202, errors: ['PAYLOAD_TOO_LARGE'], spec: 'tech/03 §17; tech/09 §1–2', task: 'E18-T02',
});
